import { render, staticRenderFns } from "./SupportOpenTicketBtn.vue?vue&type=template&id=db31c0d6&scoped=true"
import script from "./SupportOpenTicketBtn.vue?vue&type=script&lang=js"
export * from "./SupportOpenTicketBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db31c0d6",
  null
  
)

export default component.exports